import { FolderIcon } from "lucide-react";

export const NoFundSelected = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      <div className="bg-primary/10 p-6 rounded-full mb-6">
        <FolderIcon className="h-12 w-12 text-primary" />
      </div>
      <h2 className="text-2xl font-semibold mb-2">No Fund Selected</h2>
      <p className="text-muted-foreground mb-6 max-w-md">
        Please select a fund from the sidebar to view its details and
        performance metrics.
      </p>
    </div>
  );
};

export default NoFundSelected;
